import React from 'react';
import '../../steps/styles.less';
import { SideImageContainer } from '../SideImageContainer';
import { StepButtons } from '../StepButtons';
import { StepperV2 } from 'components/Stepper';

export function GenericQuestionContainer({
  onBack,
  onNext,
  disableNext,
  currentStep,
  totalSteps,
  questionTitle,
  sideImage,
  decorationComponent: Decoration,
  whiteBackground,
  children,
  footer,
}) {
  return (
    <SideImageContainer
      sideImage={sideImage}
      whiteBackground={whiteBackground}
      decorationComponent={Decoration && <Decoration />}>
      <div className="question-container">
        <div className="header">
          <StepButtons
            onBack={onBack}
            onNext={onNext}
            disableNext={disableNext}
            secondary
          />
          <div className="stepper-overlap">
            <StepperV2 current={currentStep} total={totalSteps} />
          </div>
        </div>

        <div className="question-contents">
          <div className="question-title">
            <h2 className="label start_title">{questionTitle}</h2>
          </div>

          <div className="question-options">{children}</div>

          <div className="question-subtitle">{footer}</div>
        </div>
      </div>
    </SideImageContainer>
  );
}